import axios from "../../axios";

const getTimeline = async (resource, resource_id) => {
  try {
    const { data } = await axios.get(`/timeline?resource[$eq]=${resource}&resource_id[$eq]=${resource_id}`);
    return data;
  } catch (e) {
    return null;
  }
}

const getComments = async (resource, resource_id) => {
  try {
    const { data } = await axios.get(`/timeline/comments?resource[$eq]=${resource}&resource_id[$eq]=${resource_id}`);
    return data;
  } catch (e) {
    return null;
  }
}

const postComment = async (comment, resource, resource_id) => {
  console.log(comment, resource, resource_id, "comment!!!!");
  try {
    if (!comment) throw new Error('No comment');
    const { data } = await axios.post(`/timeline/comments`, { comment, resource, resource_id });
    return data;
  } catch (e) {
    throw e;
  }
}

export { getTimeline, getComments, postComment };